import React from "react";
import { Card, Row, Col } from "antd";
import {
  CarOutlined,
  ShopOutlined,
  DollarCircleOutlined,
  ShoppingCartOutlined,
  BookOutlined,
  HeartOutlined,
  BuildOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import "./Expertise.css";

function Expertise() {
  const services = [
    {
      title: "Transport & Logistics ERP",
      des: "Enterprise-grade fleet management, RTO integration, and route optimization engines for heavy transport operations.",
      icon: <CarOutlined />,
    },
    {
      title: "Corporate Portfolios",
      des: "Stunning, lightweight digital business portfolios and high-performance showcase platforms with global standard UX.",
      icon: <ShopOutlined />,
    },
    {
      title: "FinTech & Billing Systems",
      des: "Super-fast GST invoicing, inventory tracking, and complex ledger accounting platforms tailored to commercial needs.",
      icon: <DollarCircleOutlined />,
    },
    {
      title: "E-Commerce Ecosystems",
      des: "Feature-rich online storefronts with seamless secure payment integrations, customer tracking, and real-time stock sync.",
      icon: <ShoppingCartOutlined />,
    },
    {
      title: "Solar & Green Tech Portals",
      des: "Specialized remote monitoring interfaces, lead engines, and solar system performance trackers for renewable businesses.",
      icon: <ThunderboltOutlined />,
    },
    {
      title: "E-Learning & LMS Portals",
      des: "Interactive web-based learning engines, secure video delivery, offline study hubs, and educational ERP modules.",
      icon: <BookOutlined />,
    },
    {
      title: "Healthcare & Lab Softwares",
      des: "HIPAA-aligned custom EHR/EMR panels, lab diagnostics trackers, doctor schedulers, and clinical data managers.",
      icon: <HeartOutlined />,
    },
    {
      title: "Real Estate & Construction Tech",
      des: "Comprehensive ERPs designed to manage on-site material inventories, CAD layout archives, and structural pipeline steps.",
      icon: <BuildOutlined />,
    },
  ];

  return (
    <section className="expertise-light" id="expertise">
      {/* Visual Background Grid & Ambient Glows */}
      <div className="exp-bg-grid-light"></div>
      <div className="exp-glow-light-1"></div>
      <div className="exp-glow-light-2"></div>

      <div className="container-light">
        <div className="section-header-light">
          <span className="badge-light">
            <span className="badge-dot"></span>
            WHAT WE BUILD
          </span>

          
          <p className="description-light">
            We architect and deploy specialized software blueprints tailored to optimize key business verticals and drive daily efficiency.
          </p>
        </div>

        <Row gutter={[28, 28]}>
          {services.map((item, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <Card className="expertise-card-light" bordered={false}>
                <div className="exp-icon-box-light">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.des}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}

export default Expertise;